module.exports = __webpack_public_path__ + "static/media/top_acc.eae6a27b.svg";